
const getModules = {
  imageFull: () => import(
		/* webpackChunkName: "imageFull" */ "./image-full/image-full"
	),
  imageDouble: () => import(
		/* webpackChunkName: "imageDouble" */ "./image-double/image-double"
	),
  projectIndex: () => import(
		/* webpackChunkName: "projectIndex" */ "./project-index/project-index"
	),
  surfaceIndex: () => import(
		/* webpackChunkName: "surfaceIndex" */ "./surface-index/surface-index"
	),
  collectionIndex: () => import(
		/* webpackChunkName: "collectionIndex" */ "./collection-index/collection-index"
	),
  newsIndex: () => import(
		/* webpackChunkName: "newsIndex" */ "./news-index/news-index"
	),
  newsDetail: () => import(
		/* webpackChunkName: "newsDetail" */ "./news-detail/news-detail"
	),
  placeIndex: () => import(
		/* webpackChunkName: "placeIndex" */ "./place-index/place-index"
	),
  search: () => import(
		/* webpackChunkName: "search" */ "./search/search"
	),
  readMore: () => import(
		/* webpackChunkName: "readMore" */ "./read-more/read-more"
	),
  gallery: () => import(
		/* webpackChunkName: "gallery" */ "./gallery/gallery"
	),
  lightbox: () => import(
		/* webpackChunkName: "lightbox" */ "./lightbox/lightbox"
	),
  modal: () => import(
		/* webpackChunkName: "modal" */ "./modal/modal"
	),
  download: () => import(
		/* webpackChunkName: "download" */ "./download/download"
	),
  recall: () => import(
		/* webpackChunkName: "recall" */ "./recall/recall"
	),
  next: () => import(
		/* webpackChunkName: "next" */ "./next/next"
	),
  related: () => import(
		/* webpackChunkName: "related" */ "./related/related"
	),
  latest: () => import(
		/* webpackChunkName: "latest" */ "./latest/latest"
	),
  editorial: () => import(
		/* webpackChunkName: "editorial" */ "./editorial/editorial"
	),
  focus: () => import(
		/* webpackChunkName: "focus" */ "./focus/focus"
	),
  highlights: () => import(
		/* webpackChunkName: "highlights" */ "./highlights/highlights"
	),
  carousel: () => import(
		/* webpackChunkName: "carousel" */ "./carousel/carousel"
	),
  accordion: () => import(
		/* webpackChunkName: "accordion" */ "./accordion/accordion"
	),
  hero: () => import(
		/* webpackChunkName: "hero" */ "./hero/hero"
	),
  cover: () => import(
		/* webpackChunkName: "cover" */ "./cover/cover"
	),
  typo: () => import(
		/* webpackChunkName: "typo" */ "./typo/typo"
	),
  quote: () => import(
		/* webpackChunkName: "quote" */ "./quote/quote"
	),
  product: () => import(
		/* webpackChunkName: "product" */ "./product/product"
	),
  frames: () => import(
		/* webpackChunkName: "frames" */ "./frames/frames"
	),
  features: () => import(
		/* webpackChunkName: "features" */ "./features/features"
	),
  video: () => import(
		/* webpackChunkName: "video" */ "./video/video"
	),
  footer: () => import(
		/* webpackChunkName: "video" */ "./footer/footer"
	),
  zoom: () => import(
		/* webpackChunkName: "zoom" */ "./zoom/zoom"
	),
  form: () => import(
		/* webpackChunkName: "form" */ "./form/form"
	),
	prototype: () => import(
		/* webpackChunkName: "prototype" */ "./prototype/prototype"
	)
};

export { getModules };
